import { LANGUAGES as e } from '../../../utils/languageResolver.js';
import { NUMBER_SEPARATORS as M } from '../constants/numberSeparators.js';

var t=[[[e.DE,e.PL,e.ES,e.PT,e.RU],function(r){return [Math.abs(Number(r))<1e4?M.EMPTY:M.SPACE,M.COMMA]}],[[e.FR,e.CS,e.UK],function(){return [M.SPACE,M.COMMA]}],[[e.TR,e.PT_BR,e.IT],function(){return [M.DOT,M.COMMA]}],[[e.ES_MX],function(r){return [Math.abs(Number(r))<1e4?M.EMPTY:M.SPACE,M.DOT]}],[[e.EN,e.ZH_TW,e.ZH_CN,e.KO,e.TH,e.JA],function(){return [M.COMMA,M.DOT]}],[[e.ZH_SG],function(){return [M.EMPTY,M.DOT]}]];

export { t as default };
//# sourceMappingURL=index.js.map
